export default "__VITE_ASSET__Dogo$IMJ__"